module.exports = __webpack_public_path__ + "4b6113a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/Pediatria/24573.jpg
// module id = 1326
// module chunks = 0 1